export const osDetector = {
  data() {
    return {
      os: this.detectOS(),
    }
  },
  methods: {
    detectOS() {
      const userAgent = navigator.userAgent
      const platform = navigator.platform

      let osName = 'Unknown'
      let osVersion = ''

      if (/iPad|iPhone|iPod/.test(userAgent)
        || (platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        osName = 'iOS'
        // iOS versiyonunu çıkartma (karmaşık olabilir)
        const match = userAgent.match(/OS ([0-9_]+)/)
        if (match) {
          osVersion = match[1].replace(/_/g, '.')
        }

        // iPad OS özel kontrolü
        if (platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
          osName = 'iPadOS'
        }
      } else if (/Android/.test(userAgent)) {
        osName = 'Android'
        const match = userAgent.match(/Android ([0-9.]+)/)
        if (match) {
          osVersion = match[1]
        }
      } else if (/Mac OS X/.test(userAgent) && !(/iPad|iPhone|iPod/.test(userAgent))) {
        osName = 'macOS'
        const match = userAgent.match(/Mac OS X ([0-9._]+)/)
        if (match) {
          osVersion = match[1].replace(/_/g, '.')
        }
      } else if (/Windows/.test(userAgent)) {
        osName = 'Windows'

        if (/Windows NT 10.0/.test(userAgent)) {
          osVersion = '10'
        } else if (/Windows NT 6.3/.test(userAgent)) {
          osVersion = '8.1'
        } else if (/Windows NT 6.2/.test(userAgent)) {
          osVersion = '8'
        } else if (/Windows NT 6.1/.test(userAgent)) {
          osVersion = '7'
        } else if (/Windows NT 6.0/.test(userAgent)) {
          osVersion = 'Vista'
        } else if (/Windows NT 5.1/.test(userAgent)) {
          osVersion = 'XP'
        } else if (/Windows NT 5.0/.test(userAgent)) {
          osVersion = '2000'
        }
      } else if (/Linux/.test(platform) && !/Android/.test(userAgent)) {
        osName = 'Linux'

        // Linux dağıtımlarını tespit etme
        if (/Ubuntu/.test(userAgent)) {
          osName = 'Ubuntu'
        } else if (/Debian/.test(userAgent)) {
          osName = 'Debian'
        } else if (/Fedora/.test(userAgent)) {
          osName = 'Fedora'
        }
      } else if (/CrOS/.test(userAgent)) {
        osName = 'Chrome OS'
      }

      return {
        name: osName,
        version: osVersion,
        // İşletim sistemi kontrolleri
        isIOS: osName === 'iOS' || osName === 'iPadOS',
        isIPadOS: osName === 'iPadOS',
        isAndroid: osName === 'Android',
        isMacOS: osName === 'macOS',
        isWindows: osName === 'Windows',
        isLinux: osName === 'Linux' || osName === 'Ubuntu' || osName === 'Debian' || osName === 'Fedora',
        isChromeOS: osName === 'Chrome OS',
        // Mobil platform kontrolü
        isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent),
        isTablet: /iPad|Android/.test(userAgent) && !/Mobile/.test(userAgent),
      }
    },
  },
}
